import { ICreateChecklistMaquinaEquipItensUseCase } from "../../../presentation/useCases/create/create_checklist_maquina_equip_itens_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateChecklistMaquinaEquipItensUseCase
 */

export class CreateChecklistMaquinaEquipItensUseCase implements ICreateChecklistMaquinaEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquip: number,
    ordem?: string,
    descricao?: string,
  ): Promise<number> {
    const result = await this.repository.createChecklistMaquinaEquipItem(
      idChecklistMaquinaEquip,
      ordem,
      descricao,
    );
    return result;
  }
}
